import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuturePaymentScheduledTime } from '@galaxy/inventory-ui';
import { TranslateService } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { Frequency } from '@vendasta/galaxy/frequency';

export interface FuturePaymentDisplayItemsWithCurrency {
  currencyCode: string;
  lineItems: FuturePaymentDisplayItem[];
}

export interface FuturePaymentDisplayItem {
  startDate: number;
  duration: number;
  price: number;
  frequency: Frequency;
}

@Component({
  selector: 'orders-future-payments-display',
  imports: [CommonModule, BillingUiModule],
  templateUrl: './future-payments-display.component.html',
  styleUrl: './future-payments-display.component.scss',
  standalone: true,
})
export class FuturePaymentsDisplayComponent {
  @Input() futurePayments: FuturePaymentDisplayItem[];
  @Input() currencyCode: string;
  protected readonly Frequency = Frequency;
  protected readonly FuturePaymentScheduledTime = FuturePaymentScheduledTime;
  constructor(readonly translateService: TranslateService) {}

  trackFuturePayment(index: number, startDate: number, duration: number, frequency: Frequency) {
    return `${index}-${startDate}-${duration}-${frequency}`;
  }
}
